module.exports = __webpack_public_path__ + "static/media/small-logo-gray.3037dcb0.svg";